import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import { HomePage } from './SearchApp';
const App = () => {
    return (_jsx(_Fragment, { children: _jsx(Container, { sx: {
                mt: 4,
            }, style: {
                width: '100%',
                maxWidth: '100%',
                height: '100vh',
            }, children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(HomePage, {}) }) }) }) }));
};
export default App;
